import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './components/App';
import './css/design-refresh.css';
import './css/catalog-refresh.css';

const root = document.getElementById('root');
createRoot(root).render(<App />);

